// extracted by mini-css-extract-plugin
export var table = "_uu-0";